import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit';
import { style } from './zui-card-css.js';

/**
 * Simple. Card-like. Insert content into `<zui-card>` to get the visual styling of our ZUI-defined cards.
 *
 * @element zui-card
 *
 * @slot - Default, unnamed slot; for inserting content into `<zui-card>`
 *
 * @csspart content - The content container inside `<zui-card>`; this is exposed as a CSS shadow part and can be accessed with `::part(content)`
 *
 * @cssprop [--zui-card-margin=0 0 30px] - Card margins
 * @cssprop [--zui-card-background-color=#fff] - Card background color
 */
export class ZuiCard extends ZuiBaseElement {
  static get styles() {
    return [super.styles, style];
  }

  render() {
    return html` <div part="content" class="container"> <slot></slot> </div> `;
  }
}

window.customElements.define('zui-card', ZuiCard);

declare global {
  interface HTMLElementTagNameMap {
    'zui-card': ZuiCard;
  }
}
